import React from 'react'
import {Card, Col, Row} from 'antd'
import {Tabs} from 'antd'
import {List} from 'antd'
import {Collapse} from 'antd'
import UpperCaseCell from '../../elements/Table/Cells/UpperCaseCell'
import RefreshButton from '../../elements/Buttons/RefreshButton'
import CustomSpin from '../../elements/CustomSpin'

const columns = [
  {
    Header: 'Name',
    accessor: '_key',
    Cell: UpperCaseCell,
  },
]
const {TabPane} = Tabs
const Panel = Collapse.Panel

export default function Sessions(props) {
  const {list, fetch, fetching} = props
  return (
    <CustomSpin spinning={fetching}>
      <Row style={{marginTop: '10px'}}>
        <Col offset={2} span={20}>
          <Card
            title={<h1>Rules</h1>}
            extra={<RefreshButton onClick={fetch} />}
            bordered={true}>
            <Tabs>
              {list.map(rule => (
                <TabPane tab={rule._key.toUpperCase()} key={rule._key}>
                  <Tabs tabPosition={'left'}>
                    <TabPane tab={'Read'} key={'Read'}>
                      <Collapse
                        bordered={false}
                        defaultActiveKey={rule.read.map(i => i.fn)}>
                        {rule.read.map(item => (
                          <Panel header={item.fn} key={item.fn}>
                            <List
                              itemLayout="horizontal"
                              dataSource={item.members}
                              renderItem={i => (
                                <List.Item>
                                  <List.Item.Meta title={i.fn} />
                                </List.Item>
                              )}
                            />
                          </Panel>
                        ))}
                      </Collapse>
                    </TabPane>
                    <TabPane tab={'Write'} key={'Write'}>
                      <Collapse
                        bordered={false}
                        defaultActiveKey={rule.write.map(i => i.fn)}>
                        {rule.write.map(item => (
                          <Panel header={item.fn} key={item.fn}>
                            <List
                              itemLayout="horizontal"
                              dataSource={item.members}
                              renderItem={i => (
                                <List.Item>
                                  <List.Item.Meta title={i.fn} />
                                </List.Item>
                              )}
                            />
                          </Panel>
                        ))}
                      </Collapse>
                    </TabPane>
                    <TabPane tab={'Stamp'} key={'Stamp'}>
                      <Collapse
                        bordered={false}
                        defaultActiveKey={rule.stamp.map(i => i.fn)}>
                        {rule.stamp.map(item => (
                          <Panel header={item.fn} key={item.fn}>
                            <List
                              itemLayout="horizontal"
                              dataSource={item.members}
                              renderItem={i => (
                                <List.Item>
                                  <List.Item.Meta title={i.fn} />
                                </List.Item>
                              )}
                            />
                          </Panel>
                        ))}
                      </Collapse>
                    </TabPane>
                  </Tabs>
                </TabPane>
              ))}
            </Tabs>
          </Card>
        </Col>
      </Row>
    </CustomSpin>
  )
}
